import { InputHTMLAttributes, Ref, forwardRef, memo } from 'react';
import s from './Input.module.scss';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = memo(
  forwardRef<HTMLInputElement, InputProps>(
    (
      { className, type, value, onChange, placeholder, ...props },
      ref: Ref<HTMLInputElement>,
    ) => {
      return (
        <input
          ref={ref}
          type={type}
          className={`${s.input} ${className}`}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...props}
        />
      );
    },
  ),
);
